<template>
    <header :class="['d-flex align-items-center site-header', headerAlignment, { transparent: transparentHeader }]">
        <template v-if="toggleMenuBurger && menuAlignment === 'right-reverse'">
            <div
                class="justify-content-end align-items-baseline d-flex d-lg-none menu-burger"
                v-if="showNavigation && hasNavigationSlot"
            >
                <button class="menu-button" @click="openMenu()">
                    <i class="far fa-bars"></i>
                </button>
            </div>
        </template>

        <div
            :class="[
                'col logo d-flex align-items-center',
                alignment,
                { floating: floatingLogo },
                { 'centered-logo': centeredLogo && !themeSetting('powered_by_monevo') && !coBranding?.logo },
                { 'has-nav': showNavigation && hasNavigationSlot },
            ]"
        >
            <slot name="logo"></slot>
        </div>

        <div v-if="hasStepIndicator" class="container m-0 d-none d-lg-flex">
            <slot name="step-indicator"></slot>
        </div>

        <div v-if="hasNavigationSlot" class="container m-0 d-none d-lg-flex">
            <div
                v-if="center_logo == '1' && !themeSetting('powered_by_monevo') && !coBranding?.logo"
                :class="[
                    'col logo d-flex align-items-center justify-content-center',
                    { floating: floatingLogo },
                    { 'centered-logo': centeredLogo },
                    { 'has-nav': showNavigation && hasNavigationSlot },
                ]"
            >
                <slot name="co-branding-logo"></slot>
            </div>
        </div>

        <div class="justify-content-end" :class="[toggleMenuBurger && checkMobile() ? '' : 'logo-right']">
            <ul class="d-flex m-0 list align-items-center" :class="[coAlignment]">
                <slot name="co-branding-logo"></slot>
            </ul>
        </div>
        <template v-if="toggleMenuBurger && menuAlignment === 'right'">
            <div
                class="justify-content-end align-items-baseline d-flex d-lg-none menu-burger"
                v-if="showNavigation && hasNavigationSlot"
            >
                <button class="menu-button" @click="openMenu()">
                    <i class="far fa-bars"></i>
                </button>
            </div>
        </template>

        <transition v-if="showNavigation && hasNavigationSlot" name="slide-from-left">
            <mobile-menu v-if="showMenu" class="d-lg-none">
                <slot name="navigation"></slot>
            </mobile-menu>
        </transition>
    </header>
</template>

<script>
import { useStore } from 'vuex'
import isEmpty from 'lodash/isEmpty'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    props: ['floatingLogo', 'centeredLogo', 'transparentHeader'],
    data() {
        return {
            showMenu: false,
            hasNavigationSlot: false,
            hasStepIndicator: false,
            headerAlignment: 'justify-content-center',
            coAlignment: '',
            alignment: 'justify-content-between justify-content-lg-end',
            menuAlignment: 'right',
            center_logo: false,
            navigationImage: false,
        }
    },
    created: function () {
        this.hasNavigationSlot = !!this.$slots.navigation
        this.hasStepIndicator = !!this.$slots['step-indicator']
        this.center_logo = this.themeSetting('center_logo')
        this.navigationImage = this.themeSetting('navigation_image')
        this.alignImage()

        this.emitter.on('close-menu', this.closeMenu)
    },
    computed: {
        pageData: function () {
            return this.store.state.global.page || null
        },
        showNavigation: function () {
            return !(
                this.themeSetting('menu') === false ||
                (this.pageData && this.pageData.hide_primary_navigation === '1') ||
                (this.pageData && this.pageData.template === 'result_page') ||
                this.pageData.template === 'rates_table'
            )
        },
        menu: function () {
            return this.store.state.global.data.menu || {}
        },
        primaryMenu: function () {
            return this.menu.primary || false
        },
        toggleMenuBurger: function () {
            if (parseInt(this.themeSetting('main_navigation_cta')) === 0) {
                return true
            }
            return this.primaryMenu.length
        },
        coBranding: function () {
            if (this.pageData && this.pageData.cobranding_logo) {
                return {
                    logo: this.pageData && this.pageData.cobranding_logo,
                    text: this.pageData && this.pageData.cobranding_text,
                    coAlign: this.pageData && this.pageData.align_logo_right,
                }
            }

            return null
        },
    },
    beforeUnmount() {
        this.emitter.off('close-menu')
    },
    methods: {
        openMenu: function () {
            this.showMenu = true
        },
        closeMenu: function () {
            this.showMenu = false
        },
        alignImage: function () {
            if (!(this.themeSetting('powered_by_monevo') || this.coBranding?.logo)) {
                return
            }

            if (
                (this.themeSetting('align_cobranding_logo_right') === '1' && isEmpty(this.coBranding)) ||
                this.coBranding?.coAlign === 1
            ) {
                //right
                this.coAlignment = 'justify-content-lg-start'
                this.alignment = 'justify-content-between justify-content-lg-end'
            }

            if (
                (this.themeSetting('align_cobranding_logo_right') === '0' && isEmpty(this.coBranding)) ||
                this.coBranding?.coAlign === 0
            ) {
                //left
                this.headerAlignment = 'flex-row-reverse'
                this.coAlignment = 'justify-content-end'
                this.alignment = 'justify-content-end justify-content-lg-start'
                this.menuAlignment = 'right-reverse'
            }
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import '~scss/settings/variables';

.site-header {
    background-color: var(--nav-overwrite);
    position: relative;
    width: 100%;

    @media screen and (min-width: $bp-large) {
        padding: 0px 75px;
    }

    &.transparent {
        background: transparent;
    }

    .logo-right {
        padding-right: 15px;
        @media screen and (min-width: $bp-large) {
            padding: 0px;
        }
    }

    .logo {
        height: 100%;
        padding: 5px 10px 5px 20px;

        @media screen and (min-width: $bp-large) {
            padding: 5px 0px;
        }

        @media screen and (max-width: $bp-small) {
            padding-right: 0;
        }

        img {
            height: 65px;
            max-width: 140px;
            object-fit: contain;

            @media screen and (min-width: $bp-large) {
                margin-right: -15px;
            }
        }

        &.floating {
            img {
                position: absolute;
                top: 50%;
                transform: translateY(-25%);
                z-index: 1;

                @media screen and (min-width: $bp-large) {
                    height: 100px;
                }
            }
        }

        &.centered-logo {
            @media screen and (max-width: $bp-large) {
                justify-content: center !important;

                &.has-nav {
                    img {
                        margin-left: 50px;
                    }
                }

                .partner__logo {
                    margin-left: 20px;
                }
            }

            @media screen and (max-width: $bp-small) {
                justify-content: center !important;

                &.has-nav {
                    img {
                        margin-left: 20px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: $bp-large) {
        min-height: 96px;

        .logo {
            flex: 1;

            &-right {
                flex: 1;
            }

            img {
                max-width: 185px;
            }
        }
    }

    .list {
        font-size: rem(15px);
        list-style: none;

        li {
            line-height: 18px;
            padding-left: 15px;
            padding-right: 15px;

            &:last-child {
                padding-right: 0;
            }

            a {
                color: var(--nav-text);
                display: block;
                font-size: rem(12px);
                font-weight: 700;

                &:hover {
                    filter: brightness(90%);
                }
            }

            @media screen and (min-width: $bp-xl) {
                a {
                    font-size: rem(15px);
                }
            }
        }
    }

    .menu-button {
        background-color: transparent;
        border: none;
        color: var(--hamburger-icon-color);
        font-size: rem(28px);
        padding-top: 10px;
    }

    .nav-button {
        white-space: nowrap;
        background: transparent;
    }

    .slide-from-left-enter-active {
        transition: all 0.3s ease;
    }

    .slide-from-left-leave-active {
        transition: all 0.3s ease;
    }

    .slide-from-left-enter,
    .slide-from-left-leave-to {
        transform: translateX(-100%);
    }
}
</style>
